export default __webpack_public_path__ + "static/media/voucher-left.b10326f7.svg";